module.exports = __webpack_public_path__ + "static/media/frontline-3-googleSeo.85a45e2d.png";